/* As Seen In — hold the marquee to a constant pixel speed.
 *
 * The scrolling itself is <marquee-component> (assets/marquee.js): it clones the
 * logo group until it covers the viewport and duplicates the run for a seamless
 * wrap. What it does NOT do well here is duration. It computes --marquee-speed
 * from the element's own width and clamps the result to 10-60s, so a narrow
 * screen lands on the 10s floor and the logos race past roughly 60% faster than
 * on desktop, from the same theme setting.
 *
 * The distance actually travelled per loop is one content copy plus one gap
 * (see the keyframe), so duration = that distance / pixels-per-second gives the
 * same visual speed at every width. We write --asi-duration; marquee.js keeps
 * writing --marquee-speed, which nothing reads.
 *
 * A ResizeObserver on the content element covers both the initial clone pass and
 * later re-clones on resize, so this never has to race marquee.js's own timing.
 */
(function () {
  function apply(root) {
    var content = root.querySelector('.as-seen-in__content');
    if (!content) return;

    var speed = parseFloat(root.dataset.pxPerSecond) || 40;

    // Read the resolved column-gap off the track rather than the --asi-gap
    // custom property: the property holds a calc() (it is halved on small
    // screens) and getPropertyValue would hand back the unresolved expression,
    // which parseFloat cannot read. columnGap always comes back in pixels.
    var track = content.parentElement;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var distance = content.offsetWidth + gap;
    if (!distance) return;

    root.style.setProperty('--asi-duration', distance / speed + 's');
  }

  function init() {
    document.querySelectorAll('.as-seen-in').forEach(function (root) {
      apply(root);

      var content = root.querySelector('.as-seen-in__content');
      if (!content || !window.ResizeObserver) return;

      // Fires once marquee.js has finished cloning, and again whenever it
      // re-clones for a new width.
      new ResizeObserver(function () {
        apply(root);
      }).observe(content);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
